
export const StockDiscountValidation = (formData) => {
    const errors = {};

    if (!formData.snt_Order || !formData.snt_Order.trim()) {
        errors.snt_Order = 'This field is required';
    }

    if (!formData.FK_Stock_ID || !formData.FK_Stock_ID.trim()) {
        errors.FK_Stock_ID = 'This field is required';
    }
    if (!formData.snt_QuantityBreak) {
        errors.snt_QuantityBreak = 'This field is required';
    }
    if (!formData.dec_Discount) {
        errors.dec_Discount = 'This field is required';
    }
    if (!formData.FK_StockCategory_ID || !formData.FK_StockCategory_ID.trim()) {
        errors.FK_StockCategory_ID = 'This field is required';
    }
    
   return errors;
};

